import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { formDataSaqB } from "../../data/4.0/formDataSaqB";
import ComponentSaq from "../../components/ComponentSaq";

class SaqB extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {};
  }

  render() {
    return <ComponentSaq type="B" formDataSaq={formDataSaqB} />;
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SaqB);
